import { formattedHeaderWithStyles, productInfoHeaderStyles } from '../../common/components/product-information-header'

export const render = (displayProduct, selectedPlanCode, redline) => {
  const header1 = displayProduct.name
  const header2 = `${displayProduct.nameThai} (${selectedPlanCode})`
  return formattedHeaderWithStyles(header1, header2, redline, productInfoHeaderStyles)
}
